export default __webpack_public_path__ + "static/media/header-video-mobile.6f3d2f54.jpg";